const PROTOCOL = 'chacha-layout-editor-v1'
const EVENT_NAME = 'chacha-layout-visual-item'

function readEditorParams() {
  const query = window.location.hash.includes('?') ? window.location.hash.split('?')[1] : ''
  return new URLSearchParams(query)
}

function configuredOrigins() {
  const defaults = [
    'http://localhost:5173',
    'https://chacha.thinker.tw',
    'https://cms2026.thinker.tw'
  ]
  return (process.env.VUE_APP_PLATFORM_ORIGINS || defaults.join(','))
    .split(',')
    .map(value => value.trim().replace(/\/$/, ''))
    .filter(Boolean)
}

function resolveParentOrigin(allowedOrigins) {
  try {
    const origin = new URL(document.referrer).origin
    return allowedOrigins.includes(origin) ? origin : null
  } catch (_) {
    return null
  }
}

export function installLayoutVisualEditor(Vue, i18n) {
  const params = readEditorParams()
  const nonce = params.get('editor_nonce')
  const allowedOrigins = configuredOrigins()
  const parentOrigin = resolveParentOrigin(allowedOrigins)
  const enabled = window.self !== window.top && params.get('visual_editor') === '1' && nonce && parentOrigin

  Vue.mixin({
    created() {
      if (!enabled || typeof this.applyLayoutVisualItem !== 'function') return
      this.__layoutVisualHandler = event => this.applyLayoutVisualItem(event.detail)
      window.addEventListener(EVENT_NAME, this.__layoutVisualHandler)
    },
    beforeDestroy() {
      if (this.__layoutVisualHandler) {
        window.removeEventListener(EVENT_NAME, this.__layoutVisualHandler)
      }
    }
  })

  if (!enabled) return

  const localeMap = { 'zh-tw': 'zh-TW', 'en-us': 'en', 'ja-jp': 'ja' }
  const requestedLocale = localeMap[params.get('locale')]
  if (requestedLocale) i18n.locale = requestedLocale

  let activeTabKey = null
  let observer = null

  const post = (type, payload = null) => {
    window.parent.postMessage({ protocol: PROTOCOL, nonce, type, payload }, parentOrigin)
  }

  const removeMarker = element => {
    element.classList.remove('layout-visual-editable', 'layout-visual-focused')
    const button = element.querySelector(':scope > .layout-visual-edit-button')
    if (button) button.remove()
  }

  const refreshMarkers = () => {
    document.querySelectorAll('[data-layout-tab][data-layout-item]').forEach(element => {
      if (element.dataset.layoutTab !== activeTabKey) {
        removeMarker(element)
        return
      }
      if (element.querySelector(':scope > .layout-visual-edit-button')) return
      element.classList.add('layout-visual-editable')
      const button = document.createElement('button')
      button.type = 'button'
      button.className = 'layout-visual-edit-button'
      button.textContent = '編輯'
      button.addEventListener('click', event => {
        event.preventDefault()
        event.stopPropagation()
        post('SELECT_ITEM', {
          tabKey: element.dataset.layoutTab,
          itemKey: element.dataset.layoutItem
        })
      })
      element.appendChild(button)
    })
  }

  const dispatchItem = message => {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: message }))
  }

  const handleMessage = event => {
    if (event.origin !== parentOrigin || event.source !== window.parent) return
    const message = event.data
    if (!message || message.protocol !== PROTOCOL || message.nonce !== nonce) return

    if (message.type === 'CONFIGURE') {
      activeTabKey = message.payload && message.payload.activeTabKey
      refreshMarkers()
      return
    }

    if (message.type === 'PING') {
      post('READY')
      return
    }

    if (message.type === 'FOCUS_ITEM') {
      document.querySelectorAll('.layout-visual-focused').forEach(element => element.classList.remove('layout-visual-focused'))
      const payload = message.payload || {}
      const target = Array.from(document.querySelectorAll('[data-layout-tab][data-layout-item]'))
        .find(element => element.dataset.layoutTab === payload.tabKey && element.dataset.layoutItem === payload.itemKey)
      if (target) {
        target.classList.add('layout-visual-focused')
        target.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      return
    }

    if (['PREVIEW_ITEM', 'RESET_ITEM', 'COMMIT_ITEM'].includes(message.type)) {
      dispatchItem({ action: message.type, ...message.payload })
    }
  }

  const style = document.createElement('style')
  style.textContent = `
    .layout-visual-editable { position: relative !important; outline: 2px dashed #009ef7 !important; outline-offset: -2px; }
    .layout-visual-editable:hover, .layout-visual-focused { outline: 4px solid #009ef7 !important; z-index: 5; }
    .layout-visual-edit-button { position: absolute !important; z-index: 9999 !important; top: 8px !important; right: 8px !important; padding: 7px 14px !important; border: 0 !important; border-radius: 5px !important; background: #009ef7 !important; color: #fff !important; font: 600 14px/1 sans-serif !important; box-shadow: 0 2px 8px rgba(0,0,0,.24) !important; cursor: pointer !important; }
  `
  document.head.appendChild(style)
  window.addEventListener('message', handleMessage)
  observer = new MutationObserver(refreshMarkers)
  observer.observe(document.body, { childList: true, subtree: true })
  refreshMarkers()
  post('READY')

  window.addEventListener('beforeunload', () => {
    window.removeEventListener('message', handleMessage)
    if (observer) observer.disconnect()
  })
}
